export const accordionDefaultStyles = {
  base: {
    headingColor: '#1A1A2B',
    headingTextColor: '#fff',
    borderRadius: 12,
    borderColor: '#1A1A2B',
  },
};

type TAccordionDefaultStyles = {
  headingColor: string;
  headingTextColor: string;
  borderRadius: number;
  borderColor: string;
};

export const getDefaultStyles = (version = 'base') => {
  // throw. or return empty object with warning ???
  return (accordionDefaultStyles[version] || {}) as TAccordionDefaultStyles;
};
